var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 126,
    viewBox: "0 0 124 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2976 28.7314C89.9302 23.1321 86.5392 18.102 82.2282 13.7758C77.9171 9.45984 72.8824 6.06506 67.2894 3.69493C61.4999 1.24199 55.3383 0 49.001 0C40.6063 0 32.3667 2.24593 25.1713 6.48941C18.2653 10.5673 12.4862 16.3632 8.43359 23.2873L9.12626 23.691C17.3969 9.56334 32.6458 0.807295 49.001 0.807295C74.4745 0.807295 95.1924 21.5486 95.1924 47.0508C95.1924 72.4599 74.6192 93.1494 49.2698 93.2943V94.1016C55.5244 94.0705 61.5826 92.8285 67.2997 90.4066C72.8927 88.0365 77.9171 84.6417 82.2385 80.3258C86.5496 76.0099 89.9405 70.9695 92.308 65.3702C94.7582 59.5742 95.9987 53.4056 95.9987 47.0611C95.9987 40.7166 94.7478 34.5377 92.2976 28.7314Z",
    fill: "#6F5C91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81763 47.0416C4.81763 40.3245 6.33736 33.7005 9.25275 27.7079C9.80068 26.5798 9.39749 25.2239 8.31197 24.6029L8.26028 24.5719C7.06104 23.8784 5.53097 24.3442 4.92102 25.5965C3.58738 28.3393 2.5122 31.1958 1.71615 34.1249C0.578943 38.3166 0 42.6636 0 47.0416C0 53.6655 1.29228 60.0929 3.85618 66.1372C6.32702 71.9746 9.85237 77.222 14.3599 81.7346C18.857 86.2368 24.0985 89.7765 29.9396 92.2501C34.9123 94.3511 40.1435 95.6035 45.5194 95.9864C46.9047 96.0796 48.073 94.9928 48.073 93.6059V93.5542C48.073 92.2915 47.1012 91.2668 45.8399 91.1737C22.9406 89.5281 4.81763 70.36 4.81763 47.0416Z",
    fill: "#6F5C91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_691_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0035 87.2498C71.1798 87.2498 89.1573 69.2521 89.1573 47.0507C89.1573 24.8493 71.1798 6.85156 49.0035 6.85156C26.8271 6.85156 8.84961 24.8493 8.84961 47.0507C8.84961 69.2521 26.8271 87.2498 49.0035 87.2498Z",
    fill: "url(#paint0_linear_691_1665)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.712 86.2459C70.1632 86.2459 87.5529 68.8367 87.5529 47.3613C87.5529 25.8858 70.1632 8.47656 48.712 8.47656C27.2608 8.47656 9.87109 25.8858 9.87109 47.3613C9.87109 68.8367 27.2608 86.2459 48.712 86.2459Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8994 54.6326C49.0882 54.6326 46.2702 54.585 43.4589 54.6462C41.2113 54.7006 39.4662 53.2934 38.9501 51.0908C37.6667 45.6455 36.3086 40.2139 34.9709 34.7822C34.6518 33.4838 33.7419 32.7632 32.4109 32.7564C31.7862 32.7496 31.1547 32.7632 30.53 32.7564C29.9935 32.7496 29.6133 32.3961 29.6133 31.9134C29.6133 31.4308 30.0003 31.0705 30.5436 31.0705C31.4331 31.0773 32.3362 31.0161 33.2122 31.152C34.9438 31.4172 36.0506 32.4777 36.5531 34.1432C36.7432 34.7822 36.8926 35.4348 37.0352 36.0806C37.0895 36.3458 37.205 36.4205 37.463 36.4205C39.1131 36.407 40.7699 36.4137 42.4268 36.4137C50.5074 36.4137 58.588 36.4137 66.6685 36.4137C66.8179 36.4137 66.9605 36.4137 67.1099 36.4137C67.789 36.4341 68.1285 36.8692 67.9791 37.5354C67.5717 39.3437 67.1575 41.1452 66.7432 42.9535C66.1049 45.7475 65.4734 48.5415 64.8216 51.3287C64.3598 53.3273 62.7912 54.6054 60.7473 54.619C57.7935 54.6462 54.8464 54.6258 51.8994 54.6326ZM37.5581 38.1337C37.592 38.29 37.6124 38.4192 37.6463 38.5483C38.6513 42.6476 39.6563 46.7536 40.6545 50.8528C40.9872 52.2261 41.8836 52.9399 43.2892 52.9399C49.0339 52.9399 54.7785 52.9399 60.53 52.9399C62.0103 52.9399 62.8931 52.2261 63.219 50.7781C63.8709 47.9229 64.5228 45.0609 65.1814 42.2057C65.487 40.8597 65.7994 39.5069 66.1117 38.1337C56.5848 38.1337 47.0986 38.1337 37.5581 38.1337Z",
    fill: "#6F5C91",
    stroke: "#6F5C91",
    strokeWidth: 0.423535
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8281 61.1559C41.8349 59.0621 43.5461 57.3626 45.624 57.383C47.7222 57.4034 49.3927 59.1029 49.3791 61.2035C49.3655 63.2837 47.6747 64.956 45.6036 64.956C43.5122 64.956 41.8214 63.2565 41.8281 61.1559ZM43.519 61.1763C43.519 62.332 44.456 63.2701 45.6036 63.2701C46.7512 63.2701 47.6883 62.3252 47.6883 61.1763C47.6883 60.0206 46.758 59.0961 45.6036 59.0961C44.4357 59.0893 43.519 60.007 43.519 61.1763Z",
    fill: "#6F5C91",
    stroke: "#6F5C91",
    strokeWidth: 0.423535
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8361 61.1694C60.8361 63.27 59.1453 64.9627 57.0539 64.9559C54.9624 64.9491 53.2784 63.2496 53.2852 61.149C53.292 59.0756 54.976 57.3896 57.0471 57.3828C59.1385 57.376 60.8361 59.0756 60.8361 61.1694ZM59.1453 61.1898C59.1521 60.0205 58.2422 59.0959 57.081 59.0891C55.9199 59.0824 54.9828 60.0001 54.976 61.1558C54.9692 62.3046 55.8995 63.2564 57.0471 63.27C58.1879 63.2768 59.1385 62.3386 59.1453 61.1898Z",
    fill: "#6F5C91",
    stroke: "#6F5C91",
    strokeWidth: 0.423535
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_691_1665",
    x: 0.31617,
    y: 2.58484,
    width: 122.976,
    height: 123.066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.8002,
    dy: 17.0669
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_691_1665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_691_1665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_1665",
    x1: 73.9974,
    y1: 78.5074,
    x2: 23.9369,
    y2: 15.6428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.9196fd74b95fed44994166b998f9b469.svg";
export { ForwardRef as ReactComponent };